// extracted by mini-css-extract-plugin
export default {"responseMsg":"StatusMessage-module_responseMsg__JwPD9","error":"StatusMessage-module_error__gfouo","success":"StatusMessage-module_success__Gbhxv"};